import { Container } from 'react-bootstrap';
import { BookingTitle, StyledBooking } from './Booking.styled';
import { SearchForm } from './forms/SearchForm';

export const BookingForm = () => {
  return (
    <StyledBooking>
      <Container>
        <BookingTitle>Đặt phòng - Đào Tiên Hotel</BookingTitle>
        <SearchForm />
      </Container>
    </StyledBooking>
  );
};
